import type { AuditEntry } from '@common/types';

import { CURRENT_USER_ID } from './org-users.seed';

const ACTORS: ReadonlyArray<{ name: string; email: string; userId?: string }> = [
  { name: 'Aiden Hemmings', email: 'aiden.hemmings@suninternational.com', userId: CURRENT_USER_ID },
  { name: 'Sarah Mokoena', email: 'sarah.mokoena@suninternational.com' },
  { name: 'Devan Pillay', email: 'devan.pillay@suninternational.com' },
  { name: 'Abby Naidoo', email: 'abby.naidoo@suninternational.com' },
  { name: 'Rashida Khan', email: 'rashida.khan@suninternational.com' },
  { name: 'Kilam Reddy', email: 'kilam.reddy@suninternational.com' },
];

const EVENTS: ReadonlyArray<
  Pick<AuditEntry, 'action' | 'entityType' | 'entityLabel' | 'summary' | 'source'>
> = [
  {
    action: 'updated',
    entityType: 'Account',
    entityLabel: 'The Maslow Sandton',
    summary: 'Check-out time changed from 10:00 to 11:00',
    source: 'ui',
  },
  {
    action: 'invited',
    entityType: 'User',
    entityLabel: 'thabo.dlamini@suninternational.com',
    summary: 'Invited as Property Manager on Table Bay Hotel',
    source: 'ui',
  },
  {
    action: 'updated',
    entityType: 'Role',
    entityLabel: 'Front Office Supervisor',
    summary: 'Added service-tickets:manage',
    source: 'ui',
  },
  {
    action: 'deleted',
    entityType: 'Tag',
    entityLabel: 'Winter 2025 Promo',
    summary: 'Removed from 4 accounts',
    source: 'ui',
  },
  {
    action: 'updated',
    entityType: 'Subscription',
    entityLabel: 'Sun City Resort',
    summary: 'Tier changed from Core to Pro',
    source: 'ui',
  },
  {
    action: 'created',
    entityType: 'Questionnaire',
    entityLabel: 'Post-stay 2026 (EN)',
    summary: 'Created from group template v4',
    source: 'ui',
  },
  {
    action: 'exported',
    entityType: 'Guest data',
    entityLabel: 'DSAR export',
    summary: 'Subject access export for 1 guest',
    source: 'ui',
  },
  {
    action: 'updated',
    entityType: 'Integration',
    entityLabel: 'Booking.com',
    summary: 'Sync failed: partner credentials rejected',
    source: 'system',
  },
  {
    action: 'created',
    entityType: 'API key',
    entityLabel: 'Data warehouse export',
    summary: 'Scopes: reviews:read, guests:read',
    source: 'ui',
  },
  {
    action: 'updated',
    entityType: 'Access policy',
    entityLabel: 'Sun International',
    summary: 'MFA changed from off to optional',
    source: 'ui',
  },
  {
    action: 'signed-in',
    entityType: 'Session',
    entityLabel: 'Google SSO',
    summary: 'Signed in from 41.13.x.x (Johannesburg)',
    source: 'ui',
  },
  {
    action: 'updated',
    entityType: 'Guest',
    entityLabel: 'r.evans@example.com',
    summary: 'Unsubscribed at organisation scope',
    source: 'api',
  },
  {
    action: 'created',
    entityType: 'Department',
    entityLabel: 'Spa & Wellness',
    summary: 'Added to the group catalogue',
    source: 'ui',
  },
  {
    action: 'updated',
    entityType: 'Ticket policy',
    entityLabel: 'Sun International',
    summary: 'Critical resolution SLA reduced to 8 hours',
    source: 'ui',
  },
  {
    action: 'deleted',
    entityType: 'Webhook',
    entityLabel: 'hooks.slack.com/…',
    summary: 'Disabled after 12 consecutive failures',
    source: 'system',
  },
];

const DAY_MS = 24 * 60 * 60 * 1000;
const BASE = Date.parse('2026-08-31T08:30:00.000Z');

function buildEntries(): AuditEntry[] {
  return Array.from({ length: 60 }, (_, index) => {
    const event = EVENTS[index % EVENTS.length];
    const actor = ACTORS[index % ACTORS.length];
    return {
      id: `audit-${index + 1}`,
      atIso: new Date(BASE - index * (DAY_MS / 3) - (index % 5) * 900000).toISOString(),
      actorName: event.source === 'system' ? 'GuestRevu' : actor.name,
      actorEmail: event.source === 'system' ? 'system@guestrevu.com' : actor.email,
      ...(event.source !== 'system' && actor.userId ? { actorUserId: actor.userId } : {}),
      action: event.action,
      entityType: event.entityType,
      entityLabel: event.entityLabel,
      summary: event.summary,
      source: event.source,
      organizationId: 'sun-intl',
      accountId: null,
    };
  });
}

export const AUDIT_SEED: ReadonlyArray<AuditEntry> = buildEntries();
